import type Dashboard from "../model/Dashboard";
import API, { responseOf } from "./base";

export const create = (dashboard: Dashboard): Promise<Dashboard> =>
  responseOf(API.post("/dashboards", dashboard));

export const get = (dashboardId: string): Promise<Dashboard> =>
  responseOf(API.get(`/dashboards/${dashboardId}`));

export const update = (dashboard: Dashboard): Promise<Dashboard> =>
  responseOf(API.put(`/dashboards/${dashboard.id}`, dashboard));

// Delete not allowed as variable name
const remove = async (dashboardId: string): Promise<void> => {
  await API.delete(`/dashboards/${dashboardId}`);
};
export { remove as delete };

export const byOrganization = (organizationId: string): Promise<string[]> =>
  responseOf(API.get(`/dashboards/byOrganization/${organizationId}`));

export const byKey = (
  organizationKey: string,
  dashboardKey: string,
): Promise<Dashboard> =>
  responseOf(
    API.get(
      `/dashboards/byOrganization/${organizationKey}/byKey/${dashboardKey}`,
      {
        public: true,
      },
    ),
  );

export const byUser = (
  organizationId: string,
  userId: string,
): Promise<Dashboard> =>
  responseOf(
    API.get(`/dashboards/byOrganization/${organizationId}/byUser/${userId}`),
  );
